<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<p class="dedit">To Royce and Mae,</p>
<p class="dedi">for obvious reasons</p>
<a id="page_6"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedi.vue?327b8cb3